import {
  GetTopicDataFunc,
  SocketResult,
  TopicReducerHandler,
} from "@shared/services/socket/types";
import { SocketTopics } from "@shared/types";

export class BasicHandler<Topic extends SocketTopics>
  implements TopicReducerHandler<Topic>
{
  private state = {
    counter: 0,
  };

  add() {
    ++this.state.counter;
    return this.state.counter === 1;
  }

  remove(): [boolean, boolean] {
    if (this.state.counter > 0) --this.state.counter;
    return [false, this.state.counter === 0];
  }

  getState = () => undefined;

  getData: GetTopicDataFunc<Topic> = (_, data) => {
    return data as SocketResult<Topic> | undefined;
  };
}
